




































import Vue, { PropType } from 'vue';
import { Amount } from '@herajs/client';
import JSBI from 'jsbi';

function aerRatio(a: Amount, b: Amount): number {
  // Devide BigInt by 10^18, convert to float, calculate ratio
  const aAergo = JSBI.toNumber(a.div(1e18).value as JSBI);
  const bAergo = JSBI.toNumber(b.div(1e18).value as JSBI);
  const ratio = aAergo / bAergo;
  return ratio;
}

export default Vue.extend({
  props: {
    totalVotes: Object as PropType<Amount>,
    accountVotes: Object as PropType<Amount>,
    dailyTotalAmount: Object as PropType<Amount>,
    updating: Boolean,
    basis: {
      type: String,
      default: 'votes',
    },
  },
  computed: {
    ratio(): number {
      return aerRatio(this.accountVotes, this.totalVotes);
    },
    ratioLabel(): string {
      const ratio = this.ratio;
      if (ratio < 0.000001 && this.accountVotes.compare(0) > 0) {
        return '<0.0001%';
      }
      return `${Math.round(ratio * 100 * 10000)/10000}%`; // precision = 4
    },
    expectedReward(): Amount {
      const aAergo = JSBI.toNumber(this.dailyTotalAmount.div(1e18).value as JSBI);
      return new Amount(Math.round(aAergo * this.ratio), 'aergo');
    },
  },
});
